(() => {
  const initializeGallery = (section) => {
    if (!section || section.dataset.bhlGalleryReady === 'true') return;

    const dialog = section.querySelector('[data-bhl-gallery-dialog]');
    const triggers = Array.from(section.querySelectorAll('[data-bhl-gallery-open]'));
    if (!dialog || triggers.length === 0 || typeof dialog.showModal !== 'function') return;

    const dialogImage = dialog.querySelector('[data-bhl-gallery-image]');
    const dialogCaption = dialog.querySelector('[data-bhl-gallery-caption]');
    const dialogCount = dialog.querySelector('[data-bhl-gallery-count]');
    const closeButton = dialog.querySelector('[data-bhl-gallery-close]');
    const previousButton = dialog.querySelector('[data-bhl-gallery-previous]');
    const nextButton = dialog.querySelector('[data-bhl-gallery-next]');
    let activeIndex = 0;
    let returnFocus = null;

    const showImage = (index) => {
      activeIndex = (index + triggers.length) % triggers.length;
      const trigger = triggers[activeIndex];
      dialogImage.src = trigger.dataset.fullSrc;
      dialogImage.alt = trigger.dataset.alt || '';
      dialogCaption.textContent = trigger.dataset.caption || trigger.dataset.alt || '';
      dialogCount.textContent = `${activeIndex + 1} of ${triggers.length}`;
    };

    triggers.forEach((trigger, index) => {
      trigger.addEventListener('click', () => {
        returnFocus = trigger;
        showImage(index);
        dialog.showModal();
      });
    });

    closeButton.addEventListener('click', () => dialog.close());
    previousButton.addEventListener('click', () => showImage(activeIndex - 1));
    nextButton.addEventListener('click', () => showImage(activeIndex + 1));

    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    });

    dialog.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') showImage(activeIndex - 1);
      if (event.key === 'ArrowRight') showImage(activeIndex + 1);
    });

    dialog.addEventListener('close', () => {
      dialogImage.src = '';
      if (returnFocus) returnFocus.focus();
    });

    section.dataset.bhlGalleryReady = 'true';
  };

  const initializeAll = (root = document) => {
    root.querySelectorAll('[data-bhl-gallery-section]').forEach(initializeGallery);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll());
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
